import { ReportActionTypes } from './../../../../../common/types/report.types';
import { CommentPost } from './../../../../../common/types/comment.types';
import { PostTypes } from './../../../../../common/types/content.types';
import { useContent } from 'pages/content/hooks/useContent'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useState, } from 'react'
import { useThemeSwitch } from 'hooks/theme'
import { useNotification } from 'hooks/use-notification/useNotification'
import { JobProps } from 'common/types';

export const useReport = (contentId?: string) => {
  const { mode } = useThemeSwitch()
  const { backendUser: user } = useAuth()
  const { reportContent } = useContent()
  const [isReported, setIsReported] = useState(false)

  const { notify } = useNotification()

  const handleReport = async (
    type?: string,
    post?: any,
    comment?: CommentPost,
    job?: JobProps,
    setReason?: Function,
    setReasonDescription?: Function,
    reasonDescription?: string,
    reason?: string
  ) => {
    try {
      let reportType
      let contentOwnerId

      if (type === PostTypes.ARTICLE || (!comment && type === PostTypes.ACTIVITY && post?.content[1]?.type === PostTypes.ARTICLE || post?.content[1]?.type === PostTypes.ACTIVITY)) {
        reportType = ReportActionTypes.POST
        contentOwnerId = post?.userId
      } else if (type === PostTypes.ACTIVITY) {
        reportType = ReportActionTypes.COMMENT
        contentOwnerId = comment?.userId
      } else if (type === ReportActionTypes.JOB) {
        reportType = ReportActionTypes.JOB
        contentOwnerId = job?.userId
      }

      await reportContent(user?.id, {
        contentId,
        jobId: job?.id,
        type: reportType,
        reason,
        description: reasonDescription,
        partnerId: job?.partnerId,
        reporteeId: contentOwnerId,
        status: 'open'
      })
      notify('success', 'Reported successfully')
      setReason('')
      setReasonDescription('')
    } catch (err) {
      notify('error', 'Reporting failed!')
      return err
    }
  }



  return {
    mode,
    isReported,
    setIsReported,
    handleReport,
  } as const
}
